import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { createCollectionModel } from '../../utils/collectionModel';
import { getTradingAccountsAsync, changeTradingAccountAsync } from './actions';
import { EAccountTypeNames } from '@trader/constants';
import { challengeModel } from '../challenges';

export const tradingAccountModel = types.model('tradingAccountModel', {
  tradingId: types.identifierNumber,
  platformLogin: types.string,
  isInUse: types.boolean,
  product: types.optional(types.string, ''),
  accountType: types.union(
    types.literal(EAccountTypeNames.Live),
    types.literal(EAccountTypeNames.Demo)
  ),
  currency: types.string,
  currencySymbol: types.string,
  isManagedMaster: types.boolean,
  isTradingAllowed: types.boolean,
  isDepositAllowed: types.boolean,
  challenge: types.maybeNull(
    types.late(() => types.safeReference(challengeModel))
  ),
});

interface ITradingAccountsAsync {
  getTradingAccountsAsync: typeof getTradingAccountsAsync;
  changeTradingAccountAsync: typeof changeTradingAccountAsync;
}

export const tradingAccounts = createCollectionModel<
  typeof tradingAccountModel,
  ITradingAccountsAsync
>(tradingAccountModel, {
  getTradingAccountsAsync,
  changeTradingAccountAsync,
});

export type TTradingAccountEntity = Instance<typeof tradingAccountModel>;
export type TTradingAccountsEntity = Instance<typeof tradingAccounts>;

export interface ITradingAccountEntitySnapshotOut
  extends SnapshotOut<typeof tradingAccountModel> {}
